import { getLink } from '../../../../utils/utils';
import img1 from '../../../images/lebed.jpg';

import author from './author';

const content = {
	rus: (
		`
		<div style="text-align: justify;">

			<p class="mb-3">
				Грязная холодная вода. 
				Гниль и тина вокруг. 
				Зоб, полный непереваренными корневищами тростника и рогоза.
			</p>
			<p class="mb-3">
				Потемнели и сузились глаза. 
				Отказали мускулы. 
				Из клюва – густая бурая жижа. 
			</p>
			<p class="mb-3">
				И вот – упала голова.
			</p>
			<p class="mb-5">
				Темно и тихо вокруг.
			</p>
				
			<p class="mb-3">
				Умирающий лебедь.
			</p>
			
			<div class="text-center mb-3">
				<img src=${img1} />
			</div>
			
		</div>
		`
	)
}

const itemName = {
	rus: `Умирающий лебедь`,
}

const itemDate = {
	rus: `6 февраля 2025г.`
}

const item = {
	itemlink: getLink(itemName.rus),
	rus: {
		itemName: itemName.rus,
		itemDate: itemDate.rus,
		itemContent: content.rus,
		itemAuthor: author.rus
	}
}

export default item;